import axios from 'axios';
import TaskStatus from './task-status.enum';
import Task from './task.entity';

export default class TaskService {
  static getTask(id: string, interval: number): Promise<Task> {
    return new Promise((resolve, reject) => {
      const timerId = setInterval(async () => {
        axios
          .get(`/api/v1/tasks/${id}`)
          .then((response) => new Task(response.data))
          .then((task: Task) => {
            const isSuccessful = TaskStatus.SUCCESS === task.status;
            if (isSuccessful) {
              clearInterval(timerId);
              resolve(task)
            }

            if (TaskStatus.ERROR === task.status) {
              clearInterval(timerId);
              reject(task.payload);
            }
          })
          .catch((err) => {
            clearInterval(timerId);
            resolve(err);
          });
      }, interval)
    });
  }
}
